module.exports = __webpack_public_path__ + "img/title.bafcf8ae.png";